import React, { useEffect } from "react";
import "../styles/UyariPopup.css";

export default function UyariPopup({ title = "", message, type = "info", onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // 3 saniye sonra otomatik kapanır
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`uyari-popup ${type}`}>
      {title && <strong className="uyari-title">{title}</strong>}
      <p className="uyari-message">{message}</p>
    </div>
  );
}
